import React, { useEffect } from 'react';
import '../styles/CustomCursor.css';

const CustomCursor = () => {
  useEffect(() => {
    const cursor = document.querySelector('.cursor');

    const moveCursor = (e) => {
      cursor.style.top = `${e.pageY}px`;
      cursor.style.left = `${e.pageX}px`;
    };

    const addClickEffect = () => {
      cursor.classList.add('click');
    };

    const removeClickEffect = () => {
      cursor.classList.remove('click');
    };

    const handleInteractive = (e) => {
      if (e.target.closest('a, button, input, textarea, select')) {
        cursor.classList.add('interactive');
      } else {
        cursor.classList.remove('interactive');
      }
    };

    document.addEventListener('mousemove', moveCursor);
    document.addEventListener('mousedown', addClickEffect);
    document.addEventListener('mouseup', removeClickEffect);
    document.addEventListener('mousemove', handleInteractive);

    return () => {
      document.removeEventListener('mousemove', moveCursor);
      document.removeEventListener('mousedown', addClickEffect);
      document.removeEventListener('mouseup', removeClickEffect);
      document.removeEventListener('mousemove', handleInteractive);
    };
  }, []);

  return <div className="cursor"></div>;
};

export default CustomCursor;
